import { graphql } from 'react-relay';

export const gqlUspsPickupLocations = graphql`
  query uspsPickupLocationsQuery {
    invsysUspsPickupLocations {
      ...uspsPickupLocationFragment_full
    }
  }
`;
